import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);


export const defaultLocale = "svn" ; //window.VUE_APP_DEFAULT_LANGUAGE;

let messages = {
    svn: require("./localization/svn.json"),
};

export const availableLocales = Object.keys(messages);

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: "svn",
    messages
});

export function loadTranslations() {
    Vue.http
        .get("api/v1/translations")
        .then(response => {
            for (var key in response.body) {
                i18n.setLocaleMessage(
                    key,
                    mergeDeep(messages[key], response.body[key])
                );
            }
        })
        .catch(() => {});
}

function mergeDeep(target, source) {
    const isObject = obj => obj && typeof obj === "object";

    if (!isObject(target) || !isObject(source)) {
        return source;
    }

    Object.keys(source).forEach(key => {
        const targetValue = target[key];
        const sourceValue = source[key];

        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            target[key] = targetValue.concat(sourceValue);
        } else if (isObject(targetValue) && isObject(sourceValue)) {
            target[key] = mergeDeep(
                Object.assign({}, targetValue),
                sourceValue
            );
        } else {
            target[key] = sourceValue;
        }
    });

    return target;
}

export default i18n;
